import React from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import withAppStore from './withAppStore'

/**
 * Renders children only for users at or above minLevel, redirects other users to the settings page.
 * Renders nothing until the user is loaded.
 */
function RequireLevel ({ children, data, level, minLevel }) {
  if (!data?.user?.ready) return null

  if (level < minLevel) return <Navigate to='/settings' replace />

  return children
}

RequireLevel.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.object,
  level: PropTypes.number,
  minLevel: PropTypes.number.isRequired,
}

export default withAppStore(RequireLevel)
